export const MARKETING_BASE = '/portal/marketing';

export const MARKETING_TABS = [
  { id: 'all', label: 'All', path: 'all', emoji: '📋' },
  { id: 'analytics', label: 'Analytics', path: 'analytics', emoji: '📊' },
  { id: 'website', label: 'Website', path: 'website', emoji: '🌐' },
  { id: 'reviews', label: 'Reviews', path: 'reviews', emoji: '⭐' },
  { id: 'calculators', label: 'Website Plugins', path: 'calculators', emoji: '🧩' },
  { id: 'leads-calculator', label: 'Lead Calculator', path: 'leads-calculator', emoji: '🧮' },
  { id: 'goals', label: 'Goals', path: 'goals', emoji: '🎯', hiddenInNav: true },
  { id: 'lead-roi', label: 'Lead ROI', path: 'lead-roi', hiddenInNav: true },
  { id: 'strategy', label: 'Strategy', path: 'strategy', hiddenInNav: true },
];

export const MARKETING_NAV_TABS = MARKETING_TABS.filter((tab) => !tab.hiddenInNav);

export const DEFAULT_MARKETING_TAB = 'all';

export function getActiveMarketingTabId(pathname) {
  if (!pathname?.startsWith(MARKETING_BASE)) {
    return DEFAULT_MARKETING_TAB;
  }

  const remainder = pathname.slice(MARKETING_BASE.length).replace(/^\//, '');
  if (!remainder) {
    return DEFAULT_MARKETING_TAB;
  }

  const firstSegment = remainder.split('/')[0];

  for (const tab of MARKETING_TABS) {
    const paths = tab.matchPaths || [tab.path];
    if (paths.some((p) => firstSegment === p || remainder.startsWith(`${p}/`))) {
      return tab.id;
    }
  }

  return DEFAULT_MARKETING_TAB;
}

export function getMarketingTabHref(tab) {
  if (tab.path === '' || tab.id === 'all') {
    return `${MARKETING_BASE}/all`;
  }
  return `${MARKETING_BASE}/${tab.path}`;
}
